module.exports = __webpack_public_path__ + "img/zhangfeng.b6b631a8.png";